import { HsMatrix3 } from '../../math-new/objects/matrix3.class';
import type { HsMatrix4 } from '../../math-new/objects/matrix4.class';
import { HsVector3 } from '../../math-new/objects/vector3.class';
import { HsRegularGeometryData } from './regular-geometry-data.class';

/**
 * Handles s merge geometries.
 */
export function hsMergeGeometries(data: [HsRegularGeometryData, HsMatrix4][]): HsRegularGeometryData {
  const vertices: number[] = [];
  const normals: number[] = [];
  const point: HsVector3 = HsVector3.makeZeroVector();
  const normal: HsVector3 = HsVector3.makeZeroVector();
  const rotationMatrix: HsMatrix3 = HsMatrix3.makeIdentityMatrix();
  for (let i: number = 0; i < data.length; i++) {
    const [geometryData, matrix]: [HsRegularGeometryData, HsMatrix4] = data[i];
    rotationMatrix.setFromMatrix4(matrix.values).inverse();
    for (let j: number = 0; j < geometryData.vertices.length; j += 3) {
      point.set(geometryData.vertices[j], geometryData.vertices[j + 1], geometryData.vertices[j + 2]);
      point.applyMatrix4(matrix.values);
      vertices.push(point.x, point.y, point.z);
      normal.set(geometryData.normals[j], geometryData.normals[j + 1], geometryData.normals[j + 2]);
      normal.applyMatrix3(rotationMatrix.values);
      normals.push(normal.x, normal.y, normal.z);
    }
  }
  return new HsRegularGeometryData(vertices, normals);
}
